<main class="main">
	<div class="box-fluid bgColor">
		<div class="box">
			<section class="pageNotFound">
				<div class="backHome">
					<span class="col sm12 md6 errorImg">
						<img src="assets/images/404.png" alt="Eror 404" loading="lazy"/>
					</span>
					<div class="col sm12 md6 btnGoHome">
						<h2>Page Not Found</h2>
						<span>
							<a [routerLink]="['']"> Ir a Inicio </a>
						</span>
					</div>
				</div>
				<div class="huellas">
					<img src="assets/images/huellas.svg" alt="Huellas Pawerful" loading="lazy"/>
					<img src="assets/images/perro.png" alt="Perro" loading="lazy"/>
				</div>
			</section>
		</div>
	</div>
</main>